/**
 * The X span one bar occupies on screen — what a highlight behind it fills.
 * See `docs/features/charts.md`, "Highlighting a bar".
 *
 * Midpoints to the neighbours, never `time ± interval / 2`: the
 * `DiscontinuousDateAxis` places a time between two bars by interpolating
 * between them, so Friday + 12 h on a daily chart lands a sixth of the way to
 * Monday. The midpoint of two bar times is half a slot whatever the gap.
 */

import { indexOfTime } from "./plot-hit.js";

/**
 * `{ start, end }` around the bar stamped `time`, or `undefined` when no loaded
 * bar has that time. The first and last bars mirror their one neighbour; a lone
 * bar has no slot to measure and gets none.
 */
export function barSlot(
  times: readonly number[],
  time: number,
): { start: number; end: number } | undefined {
  const i = indexOfTime((k) => times[k]!, times.length, time);
  if (i < 0 || times.length < 2) return undefined;
  const before = i > 0 ? (time - times[i - 1]!) / 2 : (times[i + 1]! - time) / 2;
  const after = i < times.length - 1 ? (times[i + 1]! - time) / 2 : before;
  return { start: time - before, end: time + after };
}
